import staticSchemas from '@wix/document-services-json-schemas/dist/refData.json'
import type { RefSchemas } from '@wix/thunderbolt-becky-types'

const dynamicSchemas: RefSchemas = {}

const getDataTypesByMapName = (mapName: string) => {
	const staticTypes = (staticSchemas as RefSchemas)[`${mapName}.json`] || {}
	const dynamicTypes = dynamicSchemas[mapName] || {}

	return { ...staticTypes, ...dynamicTypes }
}

export const setDynamicSchemas = (addedSchemas: RefSchemas) => {
	for (const mapName in addedSchemas) {
		if (!dynamicSchemas[mapName]) {
			dynamicSchemas[mapName] = {}
		}
		Object.assign(dynamicSchemas[mapName], addedSchemas[mapName])
	}
}

export const getSchema = (mapName: string, type: string) => {
	return getDataTypesByMapName(mapName)[type]
}

export const getDataTypeKeysByMapName = (mapName: string) => {
	return Object.keys(getDataTypesByMapName(mapName)) || []
}
